module.exports = __webpack_public_path__ + "img/home-03.6e5d7ab4.jpg";